import clientImage from "../../src/assets/svg/projects/client.svg";
import leaderImage from "../../src/assets/svg/projects/leader.svg";
import managementImage from "../../src/assets/svg/projects/management.svg";

export const achievementData = {
  bio: "Consistently delivered innovative technical solutions that met client needs, leading to high satisfaction and repeat business. Played a key role in improving project efficiency and ensuring timely delivery.Led successful platform integrations, enhancing operational processes and user experience, while driving impactful changes to improve overall workflow and project outcomes.",
  achievements: [
    {
      id: 1,
      title: "Team Lead",
      details: "Promoted to Team Lead...",
      date: "July 2025",
      field: "Leadership",
      image: leaderImage,
    },
    {
      id: 2,
      title: "Process Optimization",
      details: "Streamlined the development process...",
      date: "March 2024",
      field: "Process Improvement",
      image: managementImage,
    },
    {
      id: 3,
      title: "Client Appreciation",
      details: "Received recognition from an international clients...",
      date: "January 2024",
      field: "Client Relations",
      image: clientImage,
    },
  ],
};
